module.exports = __webpack_public_path__ + "static/media/img-01.1b559091.jpg";